<template>
  <TabbedBox>
    <template v-slot:tablist>
      <Tab :first="true" tabid="tab-1">
        <i class="far fa-rocket"></i> Automations
      </Tab>
    </template>
    <template v-slot:tabcontent>
      <TabPage :first="true" tabid="tab-1">

        <DataTable :columns="columnList" :url="dataURL" :displayTools="true" @rowClick="automationRuleClicked" :defaultColumnOrderIndex="0" :displayExportTools="true" exportTitle="Automation Rules">
          <template v-slot:title>
            <h3>Automation Rule List</h3>
          </template>
          <template v-slot:tools>
            <ActionButton type="new" class="btn" @click="displayNewAutomation" v-if="userHasCreatePermission(PermissionTypes.AutomationPermissionTypes.automation)"> New Automation Rule</ActionButton>
          </template>
          <template v-slot:row="row">
            <tr :key="row.data.id">
              <td class="table-data-nav-link">
                <LinkAutomation :name="row.data.name" :id="row.data.id" :newTab="false" />
              </td>
              <td>{{row.data.description}}</td>
              <td><IconBoolean :value="row.data.isActive" :displayFalse="true" /></td>
              <td>{{formatHyphenEmptyValue(formatDateTime(row.data.dateLastActionSuccess))}}</td>
              <td>{{formatDateTime(row.data.createdAt)}}</td>
            </tr>
          </template>
        </DataTable>
      </TabPage>
    </template>
  </TabbedBox>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'AutomationRuleList',
  components: {
  },
  props: {
    filterType: String
  },
  computed: {
    title() {
      return this.$route.meta.title
    },
    dataURL() {
      var params = {
      }
      return 'automations/rules?' + $.param(params)
    }
  },
  data: () => {
    return {
      breadcrumbs: [
        { title: 'Automation Rules', link: '/automations/rules'}
      ],
      columnList: [
        { title: "Name", data: "name" },
        { title: "Description", data: "description" },
        { title: "Enabled", data: "isActive", type: 'boolean' },
        { title: "Last Actioned", data: "dateLastActionSuccess", type: 'datetime' },
        { title: "Created", data: "createdAt", type: 'datetime' },
      ]
    }
  },
  created() {
  },
  methods: {
    automationRuleClicked(rowId) {
      this.$router.push(`/automations/rules/${rowId}`)
    },
    displayNewAutomation() {
      this.$router.push(`/automations/rules/new`)
    }    
  }
}
</script>
